/*
  Strap preview panel for the Easify strap add-on (Hype Locker UK, added 17 Oct 2026).

  What it does
    Inside the Easify strap box it shows a larger picture of the strap the customer picked most recently, with a caption
    ("Preview: Rubber / Black") and a link to that strap's own product page. With several straps picked it follows the
    newest pick; if that strap is un-picked it falls back to the newest one still picked; with none picked the picture
    panel is hidden, "View full details" goes to the strap product page itself, and a line at the bottom of the box
    says "Pocket watch only (long dash) no wrist strap added", in the place where Easify's "Selected strap: +price"
    line appears.

  What it does NOT do
    It only watches Easify's buttons. It never clicks, edits, moves or replaces anything Easify owns, adds no form
    fields, and touches no prices, summary line or Add to cart. Easify stays in charge of every selection.

  Which boxes, and where the pictures and links come from
    Any Easify box whose buttons are linked to strap products (product address starting "wrist-strap") is switched on by
    itself, so a new colour needs no change here. Pictures and links come from Easify itself: the picture set on each strap
    button (requested from Shopify's image CDN at a larger size) and the strap product that button is linked to (opened on
    that exact variant). The EDIT HERE block below is only needed to override them, or to switch the panel on for a box
    that is not linked to strap products. Layout and styling: hl-strap-preview.css.

  Roll back: delete the two hl-strap-preview lines from layout/theme.liquid. The files can stay.
*/
(function () {
  'use strict';

  /* ---- EDIT HERE -----------------------------------------------------------------------------------------------
     Optional. Boxes linked to strap products (see STRAP_ADDRESS below) get the preview panel with no entry here; add an
     entry only to override something, or to switch the panel on for a box that is not linked to strap products. The key
     is the option set number from the Easify address bar (.../option-sets/830117).

       watchName  names the watch in the picture description read out by screen readers,
                  e.g. "Ocho Negro with Rubber Black wrist strap".
       url        OPTIONAL. Where "View full details" goes when no strap is picked. Left empty, it goes to the strap
                  product page the buttons are linked to (no particular variant, so Shopify shows its default).
       straps     OPTIONAL. Key = the strap name exactly as it shows on its button. Leave a strap out, or leave a field
                  empty, to use what Easify already has:
                    image  picture for the preview (default: the picture on that Easify button, enlarged)
                    url    "View full details" page (default: the strap product page that button is linked to)
     A new Royal Pop colour needs nothing here: build its option set in Easify (strap links and pictures on its buttons)
     and add its watch page to the Easify page list.
  ------------------------------------------------------------------------------------------------------------------ */
  var PREVIEW_SETS = {
    '830117': {
      watchName: 'Ocho Negro',
      url: '',
      straps: {
        'Rubber / Black':     { image: '', url: '' },
        'Rubber / White':     { image: '', url: '' },
        'Bioceramic / Black': { image: '', url: '' },
        'Bioceramic / White': { image: '', url: '' }
      }
    }
  };

  var IMAGE_WIDTH = 600; // width asked of Shopify's image CDN (the original pictures are 1080 px square)
  var STRAP_ADDRESS = /^wrist-strap/; // a box whose buttons link to a product with an address like this is a strap box
  var DASH = String.fromCharCode(0x2014); // the long dash, written as a code so this file stays plain ASCII
  var TEXT = {
    preview: 'Preview:',
    details: 'View full details',
    allStraps: 'of the wrist straps', // screen-reader-only ending of the link when no strap is picked
    noStrap: 'Pocket watch only ' + DASH + ' no wrist strap added', // line at the bottom of the box while no strap is picked
    newTab: '(opens in a new tab)'
  };
  /* ---- END EDIT HERE ------------------------------------------------------------------------------------------- */

  var easify = window.TPOConfigs;
  if (!easify || window.hlStrapPreview) return; // not an Easify page, or already running
  window.hlStrapPreview = true;

  var records = {}; // option set number -> state for the box currently on the page

  function setClass(node, name, on) {
    if (node.classList.contains(name) !== on) node.classList.toggle(name, on); // only write when something changes
  }

  function make(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  /* Shopify CDN pictures: drop an old-style size suffix such as _450x450 and ask for IMAGE_WIDTH instead. */
  function sized(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.href);
      if (!/(^|\.)cdn\.shopify\.com$/.test(u.hostname) && u.pathname.indexOf('/cdn/shop/') !== 0) return url;
      u.pathname = u.pathname.replace(/_(?:\d+x\d*|x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(?=\.\w+$)/i, '');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  /* What Easify knows about a strap button: the original picture and the strap's product page. Null if unavailable. */
  function easifyValue(setId, label) {
    try {
      var sets = easify.option_sets_searchable || [];
      for (var i = 0; i < sets.length; i++) {
        var data = sets[i].data;
        if (!data || String(data.option_set_id) !== String(setId)) continue;
        var options = data.options || [];
        for (var j = 0; j < options.length; j++) {
          var values = options[j].option_types || [];
          for (var k = 0; k < values.length; k++) {
            var value = values[k];
            if (String(value.label).trim() !== label) continue;
            var meta = {};
            try { meta = JSON.parse(value.metadata || '{}'); } catch (e) { /* no metadata */ }
            // the product the button is linked to decides the address; the "url" Easify keeps in the button's metadata can be left
            // over from the option set it was copied from (a duplicated colour kept the old strap's address), so it is only a fallback
            var url = (value.product_handle && value.variant_id ? '/products/' + value.product_handle + '?variant=' + value.variant_id : '') || meta.url || '';
            return { image: value.image_url || '', url: url };
          }
        }
      }
    } catch (e) { /* Easify changed its data: fall back to the button picture */ }
    return null;
  }

  /* The strap buttons as they are on screen right now, in page order. */
  function readTiles(group) {
    var tiles = [];
    for (var i = 0; i < group.children.length; i++) {
      var tile = group.children[i];
      var label = tile.querySelector('.po-buttonOption-label');
      if (!label) continue;
      var img = tile.querySelector('img');
      tiles.push({
        label: label.textContent.replace(/\s+/g, ' ').trim(),
        selected: !!tile.querySelector('.po-buttonOption-selected'),
        thumb: img ? (img.getAttribute('src') || '') : ''
      });
    }
    return tiles;
  }

  function strapUrl(rec, tile) {
    var own = (rec.config.straps && rec.config.straps[tile.label]) || {};
    var known = easifyValue(rec.id, tile.label) || {};
    return own.url || known.url || '';
  }

  function strapFor(rec, tile) {
    var own = (rec.config.straps && rec.config.straps[tile.label]) || {};
    var known = easifyValue(rec.id, tile.label) || {};
    var watch = rec.config.watchName || (easify.current_product && easify.current_product.title) || 'Watch';
    return {
      name: tile.label,
      image: sized(own.image || known.image || tile.thumb, IMAGE_WIDTH),
      fallback: tile.thumb,
      url: strapUrl(rec, tile),
      alt: watch + ' with ' + tile.label.replace(/\s*\/\s*/g, ' ') + ' wrist strap'
    };
  }

  /* Where "View full details" goes when no strap is picked: the strap product page (the set's own url, if one is given). */
  function detailsUrl(rec, tiles) {
    if (rec.config.url) return rec.config.url;
    var urls = [];
    tiles.forEach(function (tile) {
      var url = strapUrl(rec, tile);
      if (url) urls.push(url);
    });
    if (!urls.length) return '';
    try {
      var first = new URL(urls[0], window.location.href);
      var sameProduct = urls.every(function (url) { return new URL(url, window.location.href).pathname === first.pathname; });
      if (sameProduct) return first.origin + first.pathname; // every strap is a variant of one product: link to the product itself
    } catch (e) { /* fall through to the first strap's page */ }
    return urls[0];
  }

  function buildPanel() {
    var ui = {};
    ui.root = make('div', 'hl-strap-preview');

    ui.figure = make('figure', 'hl-strap-preview__figure');
    ui.figure.hidden = true;
    ui.frame = make('div', 'hl-strap-preview__frame hl-strap-preview__frame--swapping');
    ui.img = make('img', 'hl-strap-preview__img');
    ui.img.alt = '';
    ui.img.decoding = 'async';
    ui.frame.appendChild(ui.img);
    ui.caption = make('figcaption', 'hl-strap-preview__caption');
    ui.caption.setAttribute('aria-live', 'polite');
    ui.caption.setAttribute('aria-atomic', 'true');
    ui.name = make('span', 'hl-strap-preview__name');
    ui.caption.appendChild(document.createTextNode(TEXT.preview + ' '));
    ui.caption.appendChild(ui.name);
    ui.figure.appendChild(ui.frame);
    ui.figure.appendChild(ui.caption);

    ui.link = make('a', 'hl-strap-preview__link');
    ui.link.hidden = true;
    ui.link.target = '_blank';
    ui.link.rel = 'noopener';
    ui.link.appendChild(document.createTextNode(TEXT.details + ' '));
    var arrow = make('span', '', String.fromCharCode(0x2192)); // right arrow
    arrow.setAttribute('aria-hidden', 'true');
    ui.link.appendChild(arrow);
    ui.linkNote = make('span', 'hl-strap-preview__sr'); // screen-reader-only: which strap, and that it opens a new tab
    ui.link.appendChild(ui.linkNote);

    ui.root.appendChild(ui.figure); // the link is placed in the title row by sync()

    // shown while no strap is picked; sync() puts it at the bottom of the box, where Easify's own price line goes
    ui.none = make('div', 'hl-strap-preview__none');
    ui.none.hidden = true;
    ui.none.appendChild(make('span', 'hl-strap-preview__none-text', TEXT.noStrap));
    return ui;
  }

  function setPanel(rec, visible) {
    rec.visible = visible;
    rec.ui.figure.hidden = !visible;
    setClass(rec.host, 'hl-strap-preview-on', visible);
  }

  /* The "View full details" link: shown whenever there is somewhere to send the customer. Writes only on a change. */
  function setLink(rec, url, note) {
    var link = rec.ui.link;
    if (!url) {
      if (!link.hidden) link.hidden = true;
      return;
    }
    if (link.getAttribute('href') !== url) link.href = url;
    if (rec.ui.linkNote.textContent !== note) rec.ui.linkNote.textContent = note;
    if (link.hidden) link.hidden = false;
  }

  function showDefaultLink(rec, tiles) {
    setLink(rec, detailsUrl(rec, tiles), ' ' + TEXT.allStraps + ' ' + TEXT.newTab);
  }

  /* Fade the old picture out, load the new one off screen, then fade it in. A later pick cancels an earlier one. */
  function swapPicture(rec, strap) {
    var ui = rec.ui;
    var ticket = ++rec.ticket;
    var probe = new Image();
    var triedFallback = false;
    setClass(ui.frame, 'hl-strap-preview__frame--swapping', true);
    probe.onload = function () {
      if (ticket !== rec.ticket) return;
      ui.img.src = probe.src;
      ui.img.alt = strap.alt;
      setClass(ui.frame, 'hl-strap-preview__frame--swapping', false);
    };
    probe.onerror = function () {
      if (ticket !== rec.ticket) return;
      if (!triedFallback && strap.fallback && strap.fallback !== strap.image) {
        triedFallback = true;
        probe.src = strap.fallback;
        return;
      }
      setPanel(rec, false); // no usable picture: hide the panel rather than show a broken image
    };
    probe.src = strap.image;
  }

  function showStrap(rec, tile, tiles) {
    var strap = tile ? strapFor(rec, tile) : null;
    if (!strap || !strap.image) {
      setPanel(rec, false);
      showDefaultLink(rec, tiles);
      return;
    }
    rec.ui.name.textContent = strap.name;
    if (strap.url) setLink(rec, strap.url, ' of ' + strap.name + ' strap ' + TEXT.newTab);
    else showDefaultLink(rec, tiles); // no page of its own for this strap: send the customer to the strap product page
    setPanel(rec, true);
    swapPicture(rec, strap);
  }

  /* Bring the panel in line with what Easify currently shows. Safe to call as often as needed. */
  function sync(rec) {
    setClass(rec.host, 'hl-strap-preview-host', true); // Easify re-renders can drop our classes; put them back
    setClass(rec.host, 'hl-strap-preview-on', rec.visible);

    var group = rec.host.querySelector('.po-buttons-optionGroup');
    if (!group || !group.parentNode) return;
    if (rec.ui.root.parentNode !== group.parentNode) group.parentNode.appendChild(rec.ui.root);
    // "View full details" goes at the right end of the title row (under the picture if the box has no title)
    var title = group.parentNode.querySelector('.po-label-root');
    var linkHome = title || rec.ui.root;
    if (rec.ui.link.parentNode !== linkHome) linkHome.appendChild(rec.ui.link);
    if (rec.ui.none.parentNode !== rec.host) rec.host.appendChild(rec.ui.none); // last in the box, below the buttons

    var tiles = readTiles(group);
    var picked = [];
    for (var i = 0; i < tiles.length; i++) {
      if (tiles[i].selected) picked.push(tiles[i].label);
    }
    // keep pick order: forget straps that were un-picked, add newly picked ones at the end
    var order = rec.order.filter(function (label) { return picked.indexOf(label) !== -1; });
    picked.forEach(function (label) { if (order.indexOf(label) === -1) order.push(label); });
    rec.order = order;

    var current = order.length ? order[order.length - 1] : null;
    var noneWanted = tiles.length > 0 && !current; // buttons are drawn and no strap is picked
    if (rec.ui.none.hidden === noneWanted) rec.ui.none.hidden = !noneWanted;
    if (current === rec.shown) {
      if (!current) showDefaultLink(rec, tiles); // nothing picked: keep the general link current (e.g. once Easify has drawn the buttons)
      return;
    }
    rec.shown = current;
    var tile = null;
    for (var j = 0; j < tiles.length; j++) {
      if (tiles[j].label === current) tile = tiles[j];
    }
    showStrap(rec, tile, tiles);
  }

  /* Download every strap picture once the customer first goes near the buttons, so later swaps are instant. */
  function warmUp(rec) {
    if (rec.warmed) return;
    rec.warmed = true;
    var group = rec.host.querySelector('.po-buttons-optionGroup');
    if (!group) return;
    readTiles(group).forEach(function (tile) {
      var src = strapFor(rec, tile).image;
      if (src) new Image().src = src;
    });
  }

  function attach(id, host) {
    var rec = {
      id: id,
      host: host,
      config: PREVIEW_SETS[id] || {},
      ui: buildPanel(),
      order: [],
      shown: null,
      visible: false,
      ticket: 0,
      warmed: false,
      observer: new MutationObserver(scan)
    };
    rec.observer.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    var warm = function () { warmUp(rec); };
    host.addEventListener('pointerenter', warm, { once: true });
    host.addEventListener('touchstart', warm, { once: true, passive: true });
    host.addEventListener('focusin', warm, { once: true });
    return rec;
  }

  /* True if the Easify option set with this number has buttons linked to strap products. */
  function linksToStraps(setId) {
    try {
      var sets = easify.option_sets_searchable || [];
      for (var i = 0; i < sets.length; i++) {
        var data = sets[i].data;
        if (!data || String(data.option_set_id) !== String(setId)) continue;
        var options = data.options || [];
        for (var j = 0; j < options.length; j++) {
          var values = options[j].option_types || [];
          for (var k = 0; k < values.length; k++) {
            if (STRAP_ADDRESS.test(String(values[k].product_handle || ''))) return true;
          }
        }
      }
    } catch (e) { /* Easify changed its data: only the boxes listed in PREVIEW_SETS are switched on */ }
    return false;
  }

  /* The boxes to switch on: those listed in PREVIEW_SETS, every box on the page linked to strap products, and boxes seen
     before (so a box Easify has replaced can be dropped). */
  function boxIds() {
    var ids = Object.keys(PREVIEW_SETS);
    var roots = document.querySelectorAll('.po-optionSet-root[data-option-set-id]');
    for (var i = 0; i < roots.length; i++) {
      var id = roots[i].getAttribute('data-option-set-id');
      if (ids.indexOf(id) === -1 && linksToStraps(id)) ids.push(id);
    }
    Object.keys(records).forEach(function (id) {
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  /* Find the strap boxes, set up new ones, drop ones Easify has replaced, then sync them all. */
  function scan() {
    boxIds().forEach(function (id) {
      var host = document.querySelector('.po-optionSet-root[data-option-set-id="' + id + '"]');
      var rec = records[id];
      if (rec && rec.host !== host) {
        rec.observer.disconnect();
        delete records[id];
        rec = null;
      }
      if (host && !rec) rec = records[id] = attach(id, host);
      if (rec) sync(rec);
    });
  }

  // Easify builds its box after page load and may rebuild it later, so keep watching for it appearing.
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  scan();
})();
